/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer4_settings = {
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_settings" | "ReplyListContainer5_settings">;
    readonly " $refType": "ReplyListContainer4_settings";
};
export type ReplyListContainer4_settings$data = ReplyListContainer4_settings;
export type ReplyListContainer4_settings$key = {
    readonly " $data"?: ReplyListContainer4_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer4_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer4_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer5_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '663364bf1fe2b9d72ba9c285f75b3c51';
export default node;
